import { render, staticRenderFns } from "./NotificationCarousel.vue?vue&type=template&id=4bf23051&scoped=true&"
import script from "./NotificationCarousel.vue?vue&type=script&lang=js&"
export * from "./NotificationCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCarousel.vue?vue&type=style&index=0&id=4bf23051&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf23051",
  null
  
)

export default component.exports